var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { translations } from './translations';
/**
 * Resolve OpenAPI context from the input.
 */
export function resolveOpenAPIContext(context) {
    var locale = context.locale, rest = __rest(context, ["locale"]);
    return __assign(__assign({}, rest), { translation: translations[locale !== null && locale !== void 0 ? locale : 'en'] });
}
/**
 * Get the client context from the OpenAPI context.
 */
export function getOpenAPIClientContext(context) {
    return {
        translation: context.translation,
        icons: context.icons,
        defaultInteractiveOpened: context.defaultInteractiveOpened,
        blockKey: context.blockKey,
        id: context.id,
        $$isClientContext$$: true,
    };
}
